/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { DeviceActivityType } from '../models/device-activity-type';
import { CommunicationsTechnology } from '../models/communications-technology';
import { DeviceManufacturer } from '../models/device-manufacturer';
import { Device } from '../models/device';
import { OnboardDevice } from '../models/onboard-device';
@Injectable({
  providedIn: 'root',
})
class DeviceService extends __BaseService {
  static readonly DeviceGetDeviceActivityTypesPath = '/api/Device/GetDeviceActivityTypes';
  static readonly DeviceGetCommunicationsTechnologyPath = '/api/Device/GetCommunicationsTechnology';
  static readonly DeviceGetDeviceManufacturersPath = '/api/Device/GetDeviceManufacturers';
  static readonly DeviceOnboardDevicePath = '/api/Device/OnboardDevice';
  static readonly DeviceGetDeployableDevicesPath = '/api/Device/GetDeployableDevices';
  static readonly DeviceGetDeviceByIdPath = '/api/Device/GetDeviceById';
  static readonly DeviceDeleteDeviceByIdPath = '/api/Device/DeleteDeviceById';
  static readonly DeviceUpdateDevicePath = '/api/Device/UpdateDevice';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }
  DeviceGetDeviceActivityTypesResponse(): __Observable<__StrictHttpResponse<Array<DeviceActivityType>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/Device/GetDeviceActivityTypes`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<DeviceActivityType>>;
      })
    );
  }  DeviceGetDeviceActivityTypes(): __Observable<Array<DeviceActivityType>> {
    return this.DeviceGetDeviceActivityTypesResponse().pipe(
      __map(_r => _r.body as Array<DeviceActivityType>)
    );
  }
  DeviceGetCommunicationsTechnologyResponse(): __Observable<__StrictHttpResponse<Array<CommunicationsTechnology>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/Device/GetCommunicationsTechnology`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<CommunicationsTechnology>>;
      })
    );
  }  DeviceGetCommunicationsTechnology(): __Observable<Array<CommunicationsTechnology>> {
    return this.DeviceGetCommunicationsTechnologyResponse().pipe(
      __map(_r => _r.body as Array<CommunicationsTechnology>)
    );
  }
  DeviceGetDeviceManufacturersResponse(): __Observable<__StrictHttpResponse<Array<DeviceManufacturer>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/Device/GetDeviceManufacturers`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<DeviceManufacturer>>;
      })
    );
  }  DeviceGetDeviceManufacturers(): __Observable<Array<DeviceManufacturer>> {
    return this.DeviceGetDeviceManufacturersResponse().pipe(
      __map(_r => _r.body as Array<DeviceManufacturer>)
    );
  }

  /**
   * @param device undefined
   */
  DeviceOnboardDeviceResponse(device: OnboardDevice): __Observable<__StrictHttpResponse<Device>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = device;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/Device/OnboardDevice`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Device>;
      })
    );
  }
  /**
   * @param device undefined
   */
  DeviceOnboardDevice(device: OnboardDevice): __Observable<Device> {
    return this.DeviceOnboardDeviceResponse(device).pipe(
      __map(_r => _r.body as Device)
    );
  }

  /**
   * @param customerId undefined
   */
  DeviceGetDeployableDevicesResponse(customerId?: number): __Observable<__StrictHttpResponse<Array<Device>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (customerId != null) __params = __params.set('customerId', customerId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/Device/GetDeployableDevices`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<Device>>;
      })
    );
  }
  /**
   * @param customerId undefined
   */
  DeviceGetDeployableDevices(customerId?: number): __Observable<Array<Device>> {
    return this.DeviceGetDeployableDevicesResponse(customerId).pipe(
      __map(_r => _r.body as Array<Device>)
    );
  }

  /**
   * @param deviceId undefined
   */
  DeviceGetDeviceByIdResponse(deviceId?: number): __Observable<__StrictHttpResponse<Device>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (deviceId != null) __params = __params.set('deviceId', deviceId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/Device/GetDeviceById`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Device>;
      })
    );
  }
  /**
   * @param deviceId undefined
   */
  DeviceGetDeviceById(deviceId?: number): __Observable<Device> {
    return this.DeviceGetDeviceByIdResponse(deviceId).pipe(
      __map(_r => _r.body as Device)
    );
  }

  /**
   * @param deviceId undefined
   */
  DeviceDeleteDeviceByIdResponse(deviceId?: number): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (deviceId != null) __params = __params.set('deviceId', deviceId.toString());
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/api/Device/DeleteDeviceById`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param deviceId undefined
   */
  DeviceDeleteDeviceById(deviceId?: number): __Observable<Blob> {
    return this.DeviceDeleteDeviceByIdResponse(deviceId).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param model undefined
   */
  DeviceUpdateDeviceResponse(model: Device): __Observable<__StrictHttpResponse<Device>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = model;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/api/Device/UpdateDevice`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Device>;
      })
    );
  }
  /**
   * @param model undefined
   */
  DeviceUpdateDevice(model: Device): __Observable<Device> {
    return this.DeviceUpdateDeviceResponse(model).pipe(
      __map(_r => _r.body as Device)
    );
  }
}

module DeviceService {
}

export { DeviceService }
